import { Box, Grid } from '@mui/material'
import { isArray } from 'lodash';
import React, { useEffect } from 'react'
import { FieldValues, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useRecoilValue } from 'recoil';
import AppSelectList, {
} from '../../../../Component/Common/Components/FormValidationInputs/AppSelectList';
import { MDTypography } from '../../../../Component/Common/Components/MDTypography'
import { VerificationCompanyAtom } from '../../../../State/VerificationCompany.Atom';
import {
    VerificationAgencyClientApplication
} from "../../../../Component/Model/Dto/VerificationAgency/VerificationAgencyClientApplication";
import {
    VerificationAgencyClientApplicationService
} from "../../../../Component/Api/VerificationAgency/VerificationAgencyClientApplication/VerificationAgencyClientApplicationService";
import { LoadingButton } from "@mui/lab";
import AppTextInput from "../../../../Component/Common/Components/FormValidationInputs/AppTextInput";
import AppCurrencyInput from "../../../../Component/Common/Components/FormValidationInputs/AppCurrencyInput";
import { AppDatepicker } from "../../../../Component/Common/Components/FormValidationInputs/AppDatepicker";
import { accountTypeList } from "../../../../Component/Common/Constants/Lists/DropdownListOptions";
import { offsetTimezone } from "../../../../Component/Model/helpers";
import { yupResolver } from "@hookform/resolvers/yup";
import { FinancialInformationValidationSchema } from "./FinancialInformationValidationSchema";
import { MDBox } from '../../../../Component/Common/Components/MDBox';
import { IntermediateGlobalLoading } from '../../../../Component/Common/Components/Loading/IntermediateGlobalLoading';


export const FinancialInformationDetails = () => {

    const verificationCompany = useRecoilValue(VerificationCompanyAtom);
    const [loading, setLoading] = React.useState(false);
    const [application, setApplication] = React.useState<VerificationAgencyClientApplication.VerificationAgencyClientApplicationResponse>();
    const [financialDetails, setFinancialDetails] = React.useState(-1);
    const { control, handleSubmit, formState: { isSubmitting }, reset } = useForm({
        mode: 'all',
        resolver: yupResolver(FinancialInformationValidationSchema),
    });

    const handleDataSubmit = async (data: FieldValues) => {
        try {
            const requestData = {
                vaClientApplicationId: verificationCompany.applicationId,
                turnover: data.turnover,
                netProfitAfterTax: data.netProfitAfterTax,
                numberOfEmployees: data.numberOfEmployees,
                financialYearEnd: offsetTimezone(new Date(data.financialYearEnd)),
                accountType: data.accountType.toString(),
            } as VerificationAgencyClientApplication.VerificationAgencyFinancialInformationDto;

            if (financialDetails < 0) {
                await VerificationAgencyClientApplicationService.CreateFinancialInformation(requestData);
            }
            else {
                await VerificationAgencyClientApplicationService.UpdateFinancialInformation(requestData);
            }


            toast.success("Financial Information Details Saved")
        } catch (error: any) {
            console.log(error);
            if (isArray(error)) {
                let Errors: string[] = error;
                Errors.forEach((error: string) => {
                    toast.error(error);
                });
            }
        }
    }

    const fetchFinancialDetails = async () => {
        const id = verificationCompany.applicationId;

        try {
            const response = await VerificationAgencyClientApplicationService.GetFinancialInformation(id);
            setFinancialDetails(response.data.financialInformationId || -1);

            reset(response.data);
        } catch (error) {
            console.log(error);
        }
    }

    const fetchApplication = async () => {
        try {
            const response = await VerificationAgencyClientApplicationService.GetById(verificationCompany.applicationId);
            setApplication(response.data);
        } catch (error) {
            console.log(error);
        }
    }

    const fetchData = async () => {
        setLoading(true);
        if (verificationCompany.applicationId !== -1) {
            const applicationPromise = fetchApplication();
            const financialDetailPromise = fetchFinancialDetails();
            await Promise.all([applicationPromise, financialDetailPromise])
        }
        setLoading(false);
    }

    useEffect(() => {
        fetchData();
    }, [verificationCompany.applicationId])

    if (loading) {
        return (<IntermediateGlobalLoading />);
    }
    return (
        <Box>
            <MDBox style={{ marginBottom: "10px" }}>
                <MDTypography variant='h4' fontWeight='bold'>
                    Application - {application?.referenceNumber}
                </MDTypography>
            </MDBox>
            <MDTypography graphy color='primary' variant='h6' fontWeight='bold' sx={{ mb: 1 }} >
                Financial Information
            </MDTypography>
            <form id='FinancialDetailsForm' onSubmit={handleSubmit(handleDataSubmit)}>
                <Grid container spacing={3}>
                    <Grid item xs={9}>
                        <Box mt={2}>
                            <AppCurrencyInput control={control} name="turnover" label="Turnover" />
                        </Box>
                        <Box mt={2}>
                            <AppCurrencyInput control={control} name="netProfitAfterTax" label="Net Profit After Tax" />
                        </Box>
                        <Box mt={2}>
                            <AppTextInput control={control} name="numberOfEmployees" label="Number Of Employees" />
                        </Box>
                        <Box mt={2}>
                            <AppDatepicker control={control} name="financialYearEnd" label="Financial Year End" inputFormat='yyyy/MM/dd' />
                        </Box>
                        <Grid mt={2}>
                            <AppSelectList control={control} name="accountType" label="Audited AFS or Management Accounts" items={accountTypeList} />
                        </Grid>
                        <Box mt={2}>
                            <LoadingButton loading={isSubmitting} variant='contained' form='FinancialDetailsForm' type="submit" color='primary'>
                                Save
                            </LoadingButton>
                        </Box>
                    </Grid>
                </Grid>
            </form>
        </Box>
    )
}
